<template>
  <div>
  <div
    :class="{
      hidden: ![2902, 2903, 2904, 2906].includes(userData.employmentModeId),
    }"
    class="mt-3 pb-4 mb-4 font-jumper"
    v-if="userData && userData.id && discounts"
  >
    <b-container fluid id="discounts-container" class="employee-discounts pt-4 col-12">
      <div
        :class="{
          hidden: ![2902, 2903, 2904, 2906].includes(userData.employmentModeId),
        }"
        class="data-wrapper"
        v-if="discountChildTypes"
      >
        <b-row>
          <b-col class="ml-0 profile-input-container" cols="12">
            <h1 class="employee-page-title">Kedvezmények</h1>

            <div class="employee-layout">

              <!-- 1. Három vagy több gyereket nevelő anyák kedvezménye -->
              <section
                class="employee-section-card"
                aria-label="Három vagy több gyereket nevelő anyák kedvezménye"
              >
                <header class="employee-section-header">
                  <div class="employee-toggle-row">
                    <ToggleSwitch
                      :model-value="!!discounts.hasDiscountOfMotherOfFourOrMore"
                      @update:modelValue="setDiscount('hasDiscountOfMotherOfFourOrMore', 'motherOfFourOrMore', $event)"
                    />
                    <h2 class="employee-section-title">
                      Három vagy több gyereket nevelő anyák kedvezménye
                    </h2>
                    <button
                      v-if="discounts.hasDiscountOfMotherOfFourOrMore"
                      type="button"
                      class="employee-section-toggle"
                      aria-controls="discount-mother-four-panel"
                      :aria-expanded="String(sections.motherOfFourOrMore)"
                      aria-label="Három vagy több gyereket nevelő anyák kedvezménye"
                      @click="sections.motherOfFourOrMore = !sections.motherOfFourOrMore"
                    >
                      <b-icon
                        :icon="sections.motherOfFourOrMore ? 'chevron-up' : 'chevron-down'"
                        aria-hidden="true"
                      ></b-icon>
                    </button>
                  </div>
                </header>

                <b-collapse
                  id="discount-mother-four-panel"
                  v-model="sections.motherOfFourOrMore"
                  class="employee-section-body"
                >
                  <div v-if="discounts.hasDiscountOfMotherOfFourOrMore" class="employee-fields-grid">
                    <span class="employee-field-full employee-field-hint">
                      Kérlek, add meg a gyermekek adatait!
                    </span>

                    <div class="employee-field-full">
                      <BaseButton
                        v-if="
                          discounts.discountOfMotherOfFourOrMore
                            .discountOfMotherOfFourOrMoreChildren.length === 0
                        "
                        variant="light"
                        size="sm"
                        class="m-2"
                        icon="plus"
                        icon-only
                        aria-label="Gyermek hozzáadása"
                        @click="newChild"
                      />
                      <div
                        class="mb-3"
                        v-for="(child, index) in discounts.discountOfMotherOfFourOrMore
                          .discountOfMotherOfFourOrMoreChildren"
                        :key="'child-' + index"
                      >
                        <h5 class="employee-field-sub-title">{{ index + 1 }}. gyermek</h5>
                        <div class="row">
                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Viselt név:</label>
                            <b-form-input
                              v-model="child.currentName"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].currentName'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].currentName-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Születési név:</label>
                            <b-form-input
                              v-model="child.birthName"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].birthName'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].birthName-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Születési hely:</label>
                            <b-form-input
                              v-model="child.birthPlace"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].birthPlace'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].birthPlace-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Születési dátum:</label>
                            <DatePicker
                              v-model="child.birthDate"
                              @input="copyDateToPermissionStartDate(child)"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].birthDate'
                              "
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="____col-8 employee-date-picker white-input"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].birthDate-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Adóazonosító jel:</label>
                            <b-form-input
                              v-model="child.taxId"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].taxId'
                              "
                              v-mask="taxFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].taxId-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">
                              A kedvezmény igénylésének kezdő dátuma:
                            </label>
                            <DatePicker
                              v-model="child.permissionStartDate"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].permissionStartDate'
                              "
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="____col-8 employee-date-picker white-input"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren[' +
                                index +
                                '].permissionStartDate-validation-message'
                              "
                            />
                          </div>

                          <div
                            v-if="
                              index >= 3 ||
                              index ===
                                discounts.discountOfMotherOfFourOrMore
                                  .discountOfMotherOfFourOrMoreChildren.length - 1
                            "
                            class="col-12 employee-action-column employee-action-column-no-label justify-content-end"
                          >
                            <BaseButton
                              v-if="index >= 3"
                              variant="light"
                              size="sm"
                              class="m-1"
                              icon="trash"
                              icon-only
                              aria-label="Törlés"
                              @click="removeChild(index)"
                            />
                            <BaseButton
                              v-if="
                                index ===
                                  discounts.discountOfMotherOfFourOrMore
                                    .discountOfMotherOfFourOrMoreChildren.length - 1
                              "
                              variant="light"
                              size="sm"
                              class="m-1"
                              icon="plus"
                              icon-only
                              aria-label="További gyermek hozzáadása"
                              @click="newChild"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </section>

              <!-- 2. Két gyerekes anyák SZJA kedvezménye -->
              <section
                class="employee-section-card"
                aria-label="Két gyerekes anyák SZJA kedvezménye"
              >
                <header class="employee-section-header">
                  <div class="employee-toggle-row">
                    <ToggleSwitch
                      :model-value="!!discounts.hasDiscountOfMotherOfTwo"
                      @update:modelValue="setDiscount('hasDiscountOfMotherOfTwo', 'motherOfTwo', $event)"
                    />
                    <h2 class="employee-section-title">
                      Két gyerekes anyák SZJA kedvezménye
                    </h2>
                    <button
                      v-if="discounts.hasDiscountOfMotherOfTwo"
                      type="button"
                      class="employee-section-toggle"
                      aria-controls="discount-mother-two-panel"
                      :aria-expanded="String(sections.motherOfTwo)"
                      aria-label="Két gyerekes anyák SZJA kedvezménye"
                      @click="sections.motherOfTwo = !sections.motherOfTwo"
                    >
                      <b-icon
                        :icon="sections.motherOfTwo ? 'chevron-up' : 'chevron-down'"
                        aria-hidden="true"
                      ></b-icon>
                    </button>
                  </div>
                </header>

                <b-collapse
                  id="discount-mother-two-panel"
                  v-model="sections.motherOfTwo"
                  class="employee-section-body"
                >
                  <div v-if="discounts.hasDiscountOfMotherOfTwo" class="employee-fields-grid">
                    <span class="employee-field-full employee-field-hint">
                      A kedvezményt azok a 40 év alatti személyek vehetik igénybe, akik 2025.12.31.-ig nem töltötték be a 40 éves kort.
                    </span>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Kérlek, add meg a születési dátumodat!</label>
                      <DatePicker
                        v-model="discounts.discountOfMotherOfTwo.birthDate"
                        ref="discountOfMotherOfTwo.birthDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                    </div>

                    <span class="employee-field-full employee-field-hint">
                      Kérlek, add meg a gyermekek adatait!
                    </span>

                    <div class="employee-field-full">
                      <div
                        class="mb-3"
                        v-for="(child, index) in discounts.discountOfMotherOfTwo
                          .discountOfMotherOfTwoChildren"
                        :key="'child-two-' + index"
                      >
                        <h5 class="employee-field-sub-title">{{ index + 1 }}. gyermek</h5>
                        <div class="row">
                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Viselt név:</label>
                            <b-form-input
                              v-model="child.currentName"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].currentName'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].currentName-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Születési név:</label>
                            <b-form-input
                              v-model="child.birthName"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].birthName'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].birthName-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Születési hely:</label>
                            <b-form-input
                              v-model="child.birthPlace"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].birthPlace'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].birthPlace-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Születési dátum:</label>
                            <DatePicker
                              v-model="child.birthDate"
                              @input="copyDateToPermissionStartDateForTwo(child)"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].birthDate'
                              "
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="____col-8 employee-date-picker white-input"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].birthDate-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Adóazonosító jel:</label>
                            <b-form-input
                              v-model="child.taxId"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].taxId'
                              "
                              v-mask="taxFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].taxId-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">
                              A kedvezmény igénylésének kezdő dátuma:
                            </label>
                            <DatePicker
                              v-model="child.permissionStartDate"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].permissionStartDate'
                              "
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="____col-8 employee-date-picker white-input"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfMotherOfTwo.discountOfMotherOfTwoChildren[' +
                                index +
                                '].permissionStartDate-validation-message'
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </section>

              <!-- 3. 25 év alatti fiatalok kedvezménye -->
              <section
                class="employee-section-card"
                aria-label="25 év alatti fiatalok kedvezménye"
              >
                <header class="employee-section-header">
                  <div class="employee-toggle-row">
                    <ToggleSwitch
                      :model-value="!!discounts.hasDiscountOfAgeUnder25"
                      @update:modelValue="setDiscount('hasDiscountOfAgeUnder25', 'ageUnder25', $event)"
                    />
                    <h2 class="employee-section-title">25 év alatti fiatalok kedvezménye</h2>
                    <button
                      v-if="discounts.hasDiscountOfAgeUnder25"
                      type="button"
                      class="employee-section-toggle"
                      aria-controls="discount-under25-panel"
                      :aria-expanded="String(sections.ageUnder25)"
                      aria-label="25 év alatti fiatalok kedvezménye"
                      @click="sections.ageUnder25 = !sections.ageUnder25"
                    >
                      <b-icon
                        :icon="sections.ageUnder25 ? 'chevron-up' : 'chevron-down'"
                        aria-hidden="true"
                      ></b-icon>
                    </button>
                  </div>
                </header>

                <b-collapse
                  id="discount-under25-panel"
                  v-model="sections.ageUnder25"
                  class="employee-section-body"
                >
                  <div v-if="discounts.hasDiscountOfAgeUnder25" class="employee-fields-grid">
                    <div class="data-wrapper">
                      <label class="employee-field-title">Kérlek, add meg a születési dátumodat!</label>
                      <DatePicker
                        v-model="discounts.discountOfAgeUnder25.birthDate"
                        ref="discountOfAgeUnder25.birthDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfAgeUnder25.birthDate-validation-message"
                      />
                    </div>
                  </div>
                </b-collapse>
              </section>

              <!-- 4. 30 év alatti anyák kedvezménye -->
              <section
                class="employee-section-card"
                aria-label="30 év alatti anyák kedvezménye"
              >
                <header class="employee-section-header">
                  <div class="employee-toggle-row">
                    <ToggleSwitch
                      :model-value="!!discounts.hasDiscountOfMotherUnder30"
                      @update:modelValue="setDiscount('hasDiscountOfMotherUnder30', 'motherUnder30', $event)"
                    />
                    <h2 class="employee-section-title">30 év alatti anyák kedvezménye</h2>
                    <button
                      v-if="discounts.hasDiscountOfMotherUnder30"
                      type="button"
                      class="employee-section-toggle"
                      aria-controls="discount-mother-under30-panel"
                      :aria-expanded="String(sections.motherUnder30)"
                      aria-label="30 év alatti anyák kedvezménye"
                      @click="sections.motherUnder30 = !sections.motherUnder30"
                    >
                      <b-icon
                        :icon="sections.motherUnder30 ? 'chevron-up' : 'chevron-down'"
                        aria-hidden="true"
                      ></b-icon>
                    </button>
                  </div>
                </header>

                <b-collapse
                  id="discount-mother-under30-panel"
                  v-model="sections.motherUnder30"
                  class="employee-section-body"
                >
                  <div v-if="discounts.hasDiscountOfMotherUnder30" class="employee-fields-grid">
                    <div class="data-wrapper">
                      <label class="employee-field-title">Kérlek, add meg a születési dátumodat!</label>
                      <DatePicker
                        v-model="discounts.discountOfMotherUnder30.birthDate"
                        ref="discountOfMotherUnder30.birthDate.birthDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.birthDate-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Add meg a gyermek státuszát</label>
                      <Dropdown
                        v-model="discounts.discountOfMotherUnder30.childStatus"
                        ref="discountOfMotherUnder30.childStatus"
                        :options="discountChildTypes"
                        class="____col-8"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.childStatus-validation-message"
                      />
                    </div>

                    <div
                      class="data-wrapper"
                      v-if="discounts.discountOfMotherUnder30.childStatus === 6204 || discounts.discountOfMotherUnder30.childStatus === 6206"
                    >
                      <label class="employee-field-title">Add meg a gyermek nevét</label>
                      <b-form-input
                        v-model="discounts.discountOfMotherUnder30.childName"
                        ref="discountOfMotherUnder30.childName"
                        class="____col-8"
                        trim
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.childName-validation-message"
                      />
                    </div>

                    <div class="data-wrapper" v-if="discounts.discountOfMotherUnder30.childStatus === 6204">
                      <label class="employee-field-title">Add meg a gyermek születési dátumát</label>
                      <DatePicker
                        v-model="discounts.discountOfMotherUnder30.childBirthDate"
                        ref="discountOfMotherUnder30.childBirthDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.childBirthDate-validation-message"
                      />
                    </div>

                    <div class="data-wrapper" v-if="discounts.discountOfMotherUnder30.childStatus === 6206">
                      <label class="employee-field-title">Add meg a gyermek örökbefogadásának dátumát</label>
                      <DatePicker
                        v-model="discounts.discountOfMotherUnder30.childBirthDate"
                        ref="discountOfMotherUnder30.childBirthDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.childBirthDate-validation-message"
                      />
                    </div>

                    <div
                      class="data-wrapper"
                      v-if="discounts.discountOfMotherUnder30.childStatus === 6204 || discounts.discountOfMotherUnder30.childStatus === 6206"
                    >
                      <label class="employee-field-title">Add meg a gyermek adóazonosító jelét</label>
                      <b-form-input
                        v-model="discounts.discountOfMotherUnder30.childTaxId"
                        ref="discountOfMotherUnder30.childTaxId"
                        class="____col-8"
                        v-mask="taxFilter"
                        trim
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.childTaxId-validation-message"
                      />
                    </div>

                    <div class="data-wrapper" v-if="discounts.discountOfMotherUnder30.childStatus === 6205">
                      <label class="employee-field-title">Add meg a várandósság 91. napját</label>
                      <DatePicker
                        v-model="discounts.discountOfMotherUnder30.pregnancy91thDay"
                        ref="discountOfMotherUnder30.pregnancy91thDay"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.pregnancy91thDay-validation-message"
                      />
                    </div>

                    <div class="data-wrapper employee-field-full">
                      <label class="employee-field-title">
                        A kedvezményt az alábbiak szerint kívánom igénybe venni
                      </label>
                      <b-form-group>
                        <b-form-radio
                          v-model="discounts.discountOfMotherUnder30.discountFullAmount"
                          name="some-radios"
                          :value="true"
                        >Teljes összegben</b-form-radio>
                        <b-form-radio
                          v-model="discounts.discountOfMotherUnder30.discountFullAmount"
                          name="some-radios"
                          :value="false"
                        >Rész összegben</b-form-radio>
                        <label
                          class="employee-field-title mt-3"
                          v-if="discounts.discountOfMotherUnder30.discountFullAmount === false"
                        >Add meg a kedvezmény igénybe vételének mértékét</label>
                        <b-form-input
                          v-if="discounts.discountOfMotherUnder30.discountFullAmount === false"
                          v-model="discounts.discountOfMotherUnder30.discountAmount"
                          ref="discountOfMotherUnder30.discountAmount"
                          v-mask="numberFilter"
                          class="____col-8"
                          trim
                        />
                        <div
                          class="validation-error-msg"
                          ref="discountOfMotherUnder30.discountAmount-validation-message"
                        />
                      </b-form-group>
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.discountAmount-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">
                        Add meg a kedvezmény igénybevételének a vég dátumát
                      </label>
                      <DatePicker
                        v-model="discounts.discountOfMotherUnder30.discountEndDate"
                        ref="discountOfMotherUnder30.discountEndDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfMotherUnder30.discountEndDate-validation-message"
                      />
                    </div>
                  </div>
                </b-collapse>
              </section>

              <!-- 5. Személyi kedvezmény -->
              <section
                v-if="!(currentFlatRateType == 'PART_TIME' && userData.employmentModeId == 2903)"
                class="employee-section-card"
                aria-label="Személyi kedvezmény"
              >
                <header class="employee-section-header">
                  <div class="employee-toggle-row">
                    <ToggleSwitch
                      :model-value="!!discounts.hasDiscountPersonal"
                      @update:modelValue="setDiscount('hasDiscountPersonal', 'personal', $event)"
                    />
                    <h2 class="employee-section-title">Személyi kedvezmény</h2>
                    <button
                      v-if="discounts.hasDiscountPersonal"
                      type="button"
                      class="employee-section-toggle"
                      aria-controls="discount-personal-panel"
                      :aria-expanded="String(sections.personal)"
                      aria-label="Személyi kedvezmény"
                      @click="sections.personal = !sections.personal"
                    >
                      <b-icon
                        :icon="sections.personal ? 'chevron-up' : 'chevron-down'"
                        aria-hidden="true"
                      ></b-icon>
                    </button>
                  </div>
                </header>

                <b-collapse
                  id="discount-personal-panel"
                  v-model="sections.personal"
                  class="employee-section-body"
                >
                  <div
                    v-if="discounts.hasDiscountPersonal"
                    class="employee-fields-grid employee-personal-fields"
                  >
                    <span class="employee-field-full employee-field-hint">
                      Kérlek, add meg a következő, személyi kedvezmény számításához szükséges adatokat!
                    </span>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Jogosultság időtartama:</label>
                      <Dropdown
                        v-model="discounts.discountPersonal.periodOfPermission"
                        ref="discountPersonal.periodOfPermission"
                        :options="periodOfPermissions"
                        class="____col-8 block"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountPersonal.periodOfPermission-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <div class="employee-field-heading">
                        <label
                          for="discount-personal-start-date"
                          class="employee-field-title"
                        >Kezdete</label>
                        <InformationPopover
                          content="Orvosi igazoláson szereplő dátum VAGY az elletás folyósításának kezdeti dátuma:"
                          aria-label="Kezdete mező információ"
                        />
                      </div>
                      <DatePicker
                        id="discount-personal-start-date"
                        v-model="discounts.discountPersonal.startDateOfPermission"
                        ref="discountPersonal.startDateOfPermission"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker employee-personal-date-input white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountPersonal.startDateOfPermission-validation-message"
                      />
                    </div>

                    <div
                      class="data-wrapper"
                      v-if="
                        periodOfPermissions[
                          discounts.discountPersonal.periodOfPermission
                        ]
                      "
                    >
                      <div
                        v-if="
                          periodOfPermissions[
                            discounts.discountPersonal.periodOfPermission
                          ].value == 1
                        "
                      >
                        <label class="employee-field-title">Jogosultság vége:</label>
                        <DatePicker
                          v-model="discounts.discountPersonal.endDateOfPermission"
                          ref="discountPersonal.endDateOfPermission"
                          format="YYYY-MM-DD"
                          value-type="format"
                          class="____col-8 employee-date-picker employee-personal-date-input white-input"
                        />
                        <div
                          class="validation-error-msg"
                          ref="discountPersonal.endDateOfPermission-validation-message"
                        />
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </section>

              <section
                v-if="(currentFlatRateType == 'PART_TIME' && userData.employmentModeId == 2903)"
                class="employee-section-card employee-section-card-disabled"
                aria-label="Személyi kedvezmény (mellékállás mellett nem választható)"
              >
                <header class="employee-section-header employee-section-header-plain">
                  <div class="employee-toggle-row">
                    <ToggleSwitch :model-value="false" :disabled="true" />
                    <h2 class="employee-section-title">
                      Személyi kedvezmény (mellékállás mellett nem választható)
                    </h2>
                  </div>
                </header>
              </section>

              <!-- 6. Első házasok kedvezménye -->
              <section
                class="employee-section-card"
                aria-label="Első házasok kedvezménye"
              >
                <header class="employee-section-header">
                  <div class="employee-toggle-row">
                    <ToggleSwitch
                      :model-value="!!discounts.hasDiscountOfFirstMarriage"
                      @update:modelValue="setDiscount('hasDiscountOfFirstMarriage', 'firstMarriage', $event)"
                    />
                    <h2 class="employee-section-title">Első házasok kedvezménye</h2>
                    <button
                      v-if="discounts.hasDiscountOfFirstMarriage"
                      type="button"
                      class="employee-section-toggle"
                      aria-controls="discount-first-marriage-panel"
                      :aria-expanded="String(sections.firstMarriage)"
                      aria-label="Első házasok kedvezménye"
                      @click="sections.firstMarriage = !sections.firstMarriage"
                    >
                      <b-icon
                        :icon="sections.firstMarriage ? 'chevron-up' : 'chevron-down'"
                        aria-hidden="true"
                      ></b-icon>
                    </button>
                  </div>
                </header>

                <b-collapse
                  id="discount-first-marriage-panel"
                  v-model="sections.firstMarriage"
                  class="employee-section-body"
                >
                  <div v-if="discounts.hasDiscountOfFirstMarriage" class="employee-fields-grid">
                    <span class="employee-field-full employee-field-hint">
                      Kérlek, add meg a házasság/BÉT dátumát!
                    </span>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Házasság/BÉT dátuma:</label>
                      <DatePicker
                        v-model="discounts.discountOfFirstMarriage.dateOfMarriage"
                        ref="discountOfFirstMarriage.dateOfMarriage"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.dateOfMarriage-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Házasság/BÉT megszűnésének dátuma:</label>
                      <DatePicker
                        v-model="discounts.discountOfFirstMarriage.dateOfDivorce"
                        ref="discountOfFirstMarriage.dateOfDivorce"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.dateOfDivorce-validation-message"
                      />
                    </div>

                    <span class="employee-field-full employee-field-hint">
                      Kérlek, add meg a házastárs/élettárs adatait!
                    </span>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Viselt név:</label>
                      <b-form-input
                        v-model="discounts.discountOfFirstMarriage.partnerCurrentName"
                        ref="discountOfFirstMarriage.partnerCurrentName"
                        v-mask="letterFilter"
                        class="____col-8"
                        trim
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.partnerCurrentName-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Születési név:</label>
                      <b-form-input
                        v-model="discounts.discountOfFirstMarriage.partnerBirthName"
                        ref="discountOfFirstMarriage.partnerBirthName"
                        v-mask="letterFilter"
                        class="____col-8"
                        trim
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.partnerBirthName-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Születési hely:</label>
                      <b-form-input
                        v-model="discounts.discountOfFirstMarriage.partnerBirthPlace"
                        ref="discountOfFirstMarriage.partnerBirthPlace"
                        v-mask="letterFilter"
                        class="____col-8"
                        trim
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.partnerBirthPlace-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Születési dátum:</label>
                      <DatePicker
                        v-model="discounts.discountOfFirstMarriage.partnerBirthDate"
                        ref="discountOfFirstMarriage.partnerBirthDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="____col-8 employee-date-picker white-input"
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.partnerBirthDate-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Anyja neve:</label>
                      <b-form-input
                        v-model="discounts.discountOfFirstMarriage.partnerMotherName"
                        ref="discountOfFirstMarriage.partnerMotherName"
                        v-mask="letterFilter"
                        class="____col-8"
                        trim
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.partnerMotherName-validation-message"
                      />
                    </div>

                    <div class="data-wrapper">
                      <label class="employee-field-title">Adóazonosító jel:</label>
                      <b-form-input
                        v-model="discounts.discountOfFirstMarriage.partnerTaxId"
                        ref="discountOfFirstMarriage.partnerTaxId"
                        v-mask="taxFilter"
                        class="____col-8"
                        trim
                      />
                      <div
                        class="validation-error-msg"
                        ref="discountOfFirstMarriage.partnerTaxId-validation-message"
                      />
                    </div>
                  </div>
                </b-collapse>
              </section>

              <!-- 7. Családi kedvezmény -->
              <section
                v-if="!(currentFlatRateType == 'PART_TIME' && userData.employmentModeId == 2903)"
                class="employee-section-card"
                aria-label="Családi kedvezmény"
              >
                <header class="employee-section-header">
                  <div class="employee-toggle-row">
                    <ToggleSwitch
                      :model-value="!!discounts.hasDiscountOfFamily"
                      @update:modelValue="setDiscount('hasDiscountOfFamily', 'family', $event)"
                    />
                    <h2 class="employee-section-title">Családi kedvezmény</h2>
                    <button
                      v-if="discounts.hasDiscountOfFamily"
                      type="button"
                      class="employee-section-toggle"
                      aria-controls="discount-family-panel"
                      :aria-expanded="String(sections.family)"
                      aria-label="Családi kedvezmény"
                      @click="sections.family = !sections.family"
                    >
                      <b-icon
                        :icon="sections.family ? 'chevron-up' : 'chevron-down'"
                        aria-hidden="true"
                      ></b-icon>
                    </button>
                  </div>
                </header>

                <b-collapse
                  id="discount-family-panel"
                  v-model="sections.family"
                  class="employee-section-body"
                >
                  <div v-if="discounts.hasDiscountOfFamily" class="employee-fields-grid">
                    <span class="employee-field-full employee-field-hint">
                      Kérlek, add meg a családi kedvezményhez az alábbi adatokat!
                    </span>

                    <div class="employee-field-full">
                      <h5 class="employee-field-sub-title">HOZZÁTARTOZÓ</h5>

                      <BaseButton
                        v-if="
                          discounts.discountOfFamily.discountOfFamilyMembers.length === 0
                        "
                        variant="light"
                        size="sm"
                        class="m-2"
                        icon="plus"
                        icon-only
                        aria-label="Hozzátartozó hozzáadása"
                        @click="newFamilyMember"
                      />
                      <div
                        class="mb-3"
                        v-for="(familyMember, index) in discounts.discountOfFamily
                          .discountOfFamilyMembers"
                        :key="'relative-' + index"
                      >
                        <h5 class="employee-field-sub-title">{{ index + 1 }}. hozzátartozó</h5>
                        <div class="row">
                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">HOZZÁTARTOZÓ</label>
                            <Dropdown
                              v-model="familyMember.monthlyDiscount"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].monthlyDiscount'
                              "
                              :options="familyMemberMonthlyDiscounts"
                              class="____col-8"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].monthlyDiscount-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Jogosultság:</label>
                            <Dropdown
                              v-model="familyMember.permission"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].permission'
                              "
                              :options="familyMemberPermissions"
                              class="____col-8"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].permission-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Viselt név:</label>
                            <b-form-input
                              v-model="familyMember.currentName"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].currentName'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].currentName-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2" v-if="familyMember.permission != 4305">
                            <label class="mb-1 employee-field-title">Születési név:</label>
                            <b-form-input
                              v-model="familyMember.birthName"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].birthName'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].birthName-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2" v-if="familyMember.permission != 4305">
                            <label class="mb-1 employee-field-title">Születési hely:</label>
                            <b-form-input
                              v-model="familyMember.birthPlace"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].birthPlace'
                              "
                              v-mask="letterFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].birthPlace-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2" v-if="familyMember.permission != 4305">
                            <label class="mb-1 employee-field-title">Születési dátum:</label>
                            <DatePicker
                              v-model="familyMember.birthDate"
                              @input="copyBirthDateToPermissionStartDate(familyMember)"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].birthDate'
                              "
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="____col-8 employee-date-picker white-input"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].birthDate-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2" v-if="familyMember.permission == 4305">
                            <label class="mb-1 employee-field-title">Várandósság kezdete:</label>
                            <DatePicker
                              v-model="familyMember.startDateOfPregnancy"
                              @input="
                                copyStartDateOfPregnancyPermissionStartDate(
                                  familyMember
                                )
                              "
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].startDateOfPregnancy'
                              "
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="____col-8 employee-date-picker white-input"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].startDateOfPregnancy-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2" v-if="familyMember.permission != 4305">
                            <label class="mb-1 employee-field-title">Adóazonosító jel:</label>
                            <b-form-input
                              v-model="familyMember.taxId"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].taxId'
                              "
                              v-mask="taxFilter"
                              class="____col-8"
                              trim
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].taxId-validation-message'
                              "
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">
                              A kedvezmény igénylésének kezdő dátuma:
                            </label>
                            <DatePicker
                              v-model="familyMember.permissionStartDate"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].permissionStartDate'
                              "
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="____col-8 employee-date-picker white-input"
                            />
                            <div
                              class="validation-error-msg"
                              :ref="
                                'discountOfFamily.discountOfFamilyMembers[' +
                                index +
                                '].permissionStartDate-validation-message'
                              "
                            />
                          </div>

                          <div
                            v-if="
                              index >= 1 ||
                              index ===
                                discounts.discountOfFamily.discountOfFamilyMembers.length - 1
                            "
                            class="col-12 employee-action-column employee-action-column-no-label justify-content-end"
                          >
                            <BaseButton
                              v-if="index >= 1"
                              variant="light"
                              size="sm"
                              class="m-1"
                              icon="trash"
                              icon-only
                              aria-label="Törlés"
                              @click="removeFamilyMember(index)"
                            />
                            <BaseButton
                              v-if="
                                index ===
                                  discounts.discountOfFamily.discountOfFamilyMembers.length - 1
                              "
                              variant="light"
                              size="sm"
                              class="m-1"
                              icon="plus"
                              icon-only
                              aria-label="További hozzátartozó hozzáadása"
                              @click="newFamilyMember"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="employee-field-full">
                      <div
                        v-for="(item, index) in discounts.discountOfFamily.discountOfFamilyStatements"
                        :key="index"
                        class="mb-3"
                      >
                        <h5 class="employee-field-sub-title">ÉRVÉNYESÍTÉS</h5>

                        <div class="row">
                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Érvényesítés kezdete:</label>
                            <DatePicker
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].statementDate'"
                                v-model="item.statementDate"
                                format="YYYY-MM-DD"
                                value-type="format"
                                class="____col-8 employee-date-picker white-input"
                            />
                            <div
                                class="validation-error-msg"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].statementDate-validation-message'"
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Érvényesség vége:</label>
                            <DatePicker
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].endOfDiscount'"
                                v-model="item.endOfDiscount"
                                format="YYYY-MM-DD"
                                value-type="format"
                                class="____col-8 employee-date-picker white-input"
                            />
                            <div
                                class="validation-error-msg"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].endOfDiscount-validation-message'"
                            />
                          </div>

                          <div class="col-12 col-md-6 p-2">
                            <label class="mb-1 employee-field-title">Érvényesítés módja:</label>
                            <Dropdown
                                v-model="item.permissionType"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].permissionType'"
                                :options="discountOfFamilyPermissionTypes"
                                class="____col-8"
                            />
                            <div
                                class="validation-error-msg"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].permissionType-validation-message'"
                            />
                          </div>
                        </div>

                        <div v-if="item.permissionType === 4402">
                          <h5 class="employee-field-sub-title">Házastárs adatai:</h5>
                          <div class="row">
                            <div class="col-12 col-md-6 p-2">
                              <label class="mb-1 employee-field-title">Viselt név:</label>
                              <b-form-input
                                  v-model="item.partnerCurrentName"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerCurrentName'"
                                  v-mask="letterFilter"
                                  class="____col-8"
                                  trim
                              />
                              <div
                                  class="validation-error-msg"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerCurrentName-validation-message'"
                              />
                            </div>

                            <div class="col-12 col-md-6 p-2">
                              <label class="mb-1 employee-field-title">Születési név:</label>
                              <b-form-input
                                  v-model="item.partnerBirthName"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerBirthName'"
                                  v-mask="letterFilter"
                                  class="____col-8"
                                  trim
                              />
                              <div
                                  class="validation-error-msg"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerBirthName-validation-message'"
                              />
                            </div>

                            <div class="col-12 col-md-6 p-2">
                              <label class="mb-1 employee-field-title">Születési hely:</label>
                              <b-form-input
                                  v-model="item.partnerBirthPlace"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerBirthPlace'"
                                  v-mask="letterFilter"
                                  class="____col-8"
                                  trim
                              />
                              <div
                                  class="validation-error-msg"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerBirthPlace-validation-message'"
                              />
                            </div>

                            <div class="col-12 col-md-6 p-2">
                              <label class="mb-1 employee-field-title">Születési dátum:</label>
                              <DatePicker
                                  v-model="item.partnerBirthDate"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerBirthDate'"
                                  format="YYYY-MM-DD"
                                  value-type="format"
                                  class="____col-8 employee-date-picker white-input"
                              />
                              <div
                                  class="validation-error-msg"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerBirthDate-validation-message'"
                              />
                            </div>

                            <div class="col-12 col-md-6 p-2">
                              <label class="mb-1 employee-field-title">Anyja neve:</label>
                              <b-form-input
                                  v-model="item.partnerMotherName"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerMotherName'"
                                  v-mask="letterFilter"
                                  class="____col-8"
                                  trim
                              />
                              <div
                                  class="validation-error-msg"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerMotherName-validation-message'"
                              />
                            </div>

                            <div class="col-12 col-md-6 p-2">
                              <label class="mb-1 employee-field-title">Adóazonosító jel:</label>
                              <b-form-input
                                  v-model="item.partnerTaxId"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerTaxId'"
                                  v-mask="taxFilter"
                                  class="____col-8"
                                  trim
                              />
                              <div
                                  class="validation-error-msg"
                                  :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].partnerTaxId-validation-message'"
                              />
                            </div>
                          </div>
                        </div>

                        <h5 class="employee-field-sub-title">Nyilatkozat:</h5>
                        <div class="row">
                          <div class="col-12 p-2">
                            <div class="employee-field-heading">
                              <label
                                :for="'discount-family-statement-person-' + index"
                                class="employee-field-title"
                              >Hozzátartozók száma</label>
                              <InformationPopover
                                content="A kedvezményt hány fő hozzátartozó után kívánod igénybe venni?"
                                aria-label="Hozzátartozók száma mező információ"
                              />
                            </div>
                            <b-form-input
                                :id="'discount-family-statement-person-' + index"
                                v-model="item.statementPerson"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].statementPerson'"
                                v-mask="numberFilter"
                                class="____col-8 employee-family-statement-input"
                                trim
                            />
                            <div
                                class="validation-error-msg"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].statementPerson-validation-message'"
                            />
                          </div>

                          <div class="col-12 p-2">
                            <div class="employee-field-heading">
                              <label
                                :for="'discount-family-statement-money-' + index"
                                class="employee-field-title"
                              >Kedvezmény összege (Ft/hó)</label>
                              <InformationPopover
                                content="A kedvezményt mennyi Ft/hónap összegben kívánod igénybe venni?"
                                aria-label="Kedvezmény összege mező információ"
                              />
                            </div>
                            <b-form-input
                                :id="'discount-family-statement-money-' + index"
                                v-model="item.statementMoney"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].statementMoney'"
                                v-mask="numberFilter"
                                class="____col-8 employee-family-statement-input"
                                trim
                            />
                            <div
                                class="validation-error-msg"
                                :ref="'discountOfFamily.discountOfFamilyStatements[' + index + '].statementMoney-validation-message'"
                            />
                          </div>

                          <div class="col-12 p-2">
                            <div class="employee-toggle-row ml-4">
                              <b-form-checkbox
                                  :disabled="!item.newOne"
                                  v-model="item.inOneAmount"
                              />
                              <span class="employee-toggle-label">
                                A családi adókedvezményt egy összegben, az SZJA bevallásomban (adóévet követően) kívánom érvényesíteni.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <span class="employee-field-hint">
                        Amennyiben módosítani szeretnéd a családi kedvezmény érvényesítésének módját vagy
                        részleteit, a Módosítás gomb megnyomását követően kérjük töltsd ki az új űrlapot. (Figyelem! Az új
                        érvényesítés kezdő dátuma nem lehet a mai napnál korábbi és kizárólag a jövőben beadásra kerülő
                        bevallásokra vonatkozik!)
                      </span>

                      <div class="employee-form-actions">
                        <BaseButton
                            variant="success"
                            icon="plus"
                            label="Módosítás"
                            @click="() => {
                              discounts.discountOfFamily.discountOfFamilyStatements.push({newOne: true})
                            }"
                        />
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </section>

              <section
                v-if="(currentFlatRateType == 'PART_TIME' && userData.employmentModeId == 2903)"
                class="employee-section-card employee-section-card-disabled"
                aria-label="Családi kedvezmény (mellékállás mellett nem választható)"
              >
                <header class="employee-section-header employee-section-header-plain">
                  <div class="employee-toggle-row">
                    <ToggleSwitch :model-value="false" :disabled="true" />
                    <h2 class="employee-section-title">
                      Családi kedvezmény (mellékállás mellett nem választható)
                    </h2>
                  </div>
                </header>
              </section>

            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <div v-if="userData.employmentModeId" class="employee-floating-save-bar">
      <BaseButton
        variant="success"
        label="Mentés"
        @click="saveDiscounts"
      />
    </div>
  </div>
  </div>
</template>

<script>
import Api from "@/api/server/index";
import Util from "@/utils/Util";
import { mapGetters } from "vuex";
import BaseButton from "@/components/BaseButton.vue";
import Dropdown from "@/components/Dropdown.vue";
import InformationPopover from "@/components/InformationPopover.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/hu";

export default {
  name: "EmployeeDiscounts",

  components: { BaseButton, DatePicker, Dropdown, InformationPopover, ToggleSwitch },

  props: {
    employeeId: Number
  },

  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  data() {
    return {
      evIdList: [],

      letterFilter: "CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC",
      taxFilter: "##########",
      numberFilter: "##################################################",
      periodOfPermissions: [
        { value: 0, text: "Állandó" },
        { value: 1, text: "Ideiglenes" },
      ],
      familyMemberPermissions: [],
      familyMemberMonthlyDiscounts: [],
      discountOfFamilyPermissionTypes: [],
      discountChildTypes: [],
      discounts: null,
      sections: {
        motherOfFourOrMore: false,
        motherOfTwo: false,
        ageUnder25: false,
        motherUnder30: false,
        personal: false,
        firstMarriage: false,
        family: false,
      },
      userData: {
        id: this.$route.params.employeeId,
        employeeType: this.$route.params.type,
        companyId: this.$route.params.companyId,
        feors: [],
        circumstances: [],
        wageWithTaxes: [],
      },
      currentFlatRateType: '',

      employeeExits: {},
    };
  },
  methods: {
    isMobile() {
      return window.innerWidth <= 768;
    },

    syncSectionsWithDiscounts() {
      if (!this.discounts) {
        return;
      }

      this.sections = {
        motherOfFourOrMore: !!this.discounts.hasDiscountOfMotherOfFourOrMore,
        motherOfTwo: !!this.discounts.hasDiscountOfMotherOfTwo,
        ageUnder25: !!this.discounts.hasDiscountOfAgeUnder25,
        motherUnder30: !!this.discounts.hasDiscountOfMotherUnder30,
        personal: !!this.discounts.hasDiscountPersonal,
        firstMarriage: !!this.discounts.hasDiscountOfFirstMarriage,
        family: !!this.discounts.hasDiscountOfFamily,
      };
    },

    setDiscount(flagName, sectionKey, value) {
      this.$set(this.discounts, flagName, value);
      this.$set(this.sections, sectionKey, value);
    },

    navigateBack() {
      let url = "/app/employee/list";
      this.$router.push(url);
    },

    saveDiscounts() {
      Api.saveEmployeeDiscounts(this.discounts, this.employeeId)
          .then(() => {
            this.$toast.success({
              title: "Siker",
              message: "Sikeres hozzáadás",
            });
            Util.clearValidationErrors(
                document.getElementById("discounts-container")
            );

            Api.getEmployeeDiscounts(this.employeeId)
                .then((resp) => {
                  this.discounts = resp.data;
                  if (this.discounts.discountOfFamily.discountOfFamilyStatements.length == 0) {
                    this.discounts.discountOfFamily.discountOfFamilyStatements.push({newOne: true});
                  }

                  if (
                      this.discounts.discountOfFamily.discountOfFamilyMembers.length == 0
                  ) {
                    this.newFamilyMember();
                  }
                  if (
                      this.discounts.discountOfMotherOfFourOrMore
                          .discountOfMotherOfFourOrMoreChildren == 0
                  ) {
                    for (var j = 0; j < 3; j++) this.newChild();
                  }
                  if (
                      this.discounts.discountOfMotherOfTwo
                          .discountOfMotherOfTwoChildren == 0
                  ) {
                    for (var i = 0; i < 2; i++) this.newChildForTwo();
                  }
                  this.syncSectionsWithDiscounts();
                })
                .catch((err) => {
                  console.error(err);
                  this.$toast.error({
                    title: "Hiba",
                    message: "Api hiba",
                  });
                })
          })
          .catch((err) => {
            this.$toast.error({
              title: "Hiba",
              message: "Sikertelen hozzáadás",
            });
            Util.clearValidationErrors(
                document.getElementById("discounts-container")
            );
            Util.showValidationErrors(err, this.$refs);
          });
    },

    dateToSTR(dateString) {
      if (!dateString || dateString.length < 10) {
        return "-";
      }

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    loadDictionaries() {
      this.loadDictionary(
          Api.getFamilyMemberPermissions,
          this.familyMemberPermissions
      );
      this.loadDictionary(
          Api.getFamilyMemberMonthlyDiscounts,
          this.familyMemberMonthlyDiscounts
      );
      this.loadDictionary(
          Api.getDiscountOfFamilyPermissionTypes,
          this.discountOfFamilyPermissionTypes
      );
      this.loadDictionary(
          Api.getDiscountChildTypes,
          this.discountChildTypes,
      )
    },

    loadDictionary(api, target) {
      api()
          .then((data) => {
            data.data.content.forEach((item) =>
                target.push({ value: item.id, text: this.$cte(item.name) })
            );
          })
          .catch((err) => console.error(err));
    },

    newChild() {
      this.discounts.discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren.push(
          {
            currentName: "",
            birthName: "",
            birthPlace: "",
            birthDate: "",
            taxId: "",
            permissionStartDate: "",
          }
      );
    },

    newChildForTwo() {
      this.discounts.discountOfMotherOfTwo.discountOfMotherOfTwoChildren.push(
          {
            currentName: "",
            birthName: "",
            birthPlace: "",
            birthDate: "",
            taxId: "",
            permissionStartDate: "",
          }
      );
    },

    newFamilyMember() {
      this.discounts.discountOfFamily.discountOfFamilyMembers.push({
        monthlyDiscount: "",
        permission: "",
        currentName: "",
        birthName: "",
        birthPlace: "",
        birthDate: "",
        startDateOfPregnancy: "",
        taxId: "",
        permissionStartDate: "",
      });
    },

    removeChild(index) {
      this.discounts.discountOfMotherOfFourOrMore.discountOfMotherOfFourOrMoreChildren.splice(
          index,
          1
      );
    },

    removeFamilyMember(index) {
      this.discounts.discountOfFamily.discountOfFamilyMembers.splice(index, 1);
    },

    getTextbyKeyValue(object, value) {
      let text = "";
      object.forEach((element) => {
        if (element.value == value) {
          text = element.text;
        }
      });

      return text;
    },

    copyDateToPermissionStartDate(child) {
      child.permissionStartDate = child.birthDate;
    },

    copyDateToPermissionStartDateForTwo(child) {
      child.permissionStartDate = child.birthDate;
    },

    copyStartDateOfPregnancyPermissionStartDate(familyMember) {
      familyMember.permissionStartDate = familyMember.startDateOfPregnancy;
    },

    copyBirthDateToPermissionStartDate(familyMember) {
      familyMember.permissionStartDate = familyMember.birthDate;
    },
  },

  async mounted() {
    this.currentFlatRateType = '';
    Api.getCurrentFlatRateOfCompany(this.getActiveCompany.id).then((response) => {
      this.currentFlatRateType = response.data || 'NO';
    })

    this.evIdList = await Api.getEvIdList(this.getActiveCompany.id).then(
        (resp) => resp.data
    );

    if (this.employeeId) {
      try {
        this.userData = await Api.getEmployeeById(this.employeeId).then(
            (resp) => resp.data
        );
        this.discounts = await Api.getEmployeeDiscounts(this.employeeId).then(
            (resp) => resp.data
        );
        if (this.discounts.discountOfFamily.discountOfFamilyStatements.length == 0) {
          this.discounts.discountOfFamily.discountOfFamilyStatements.push({newOne: true});
        }

        if (
            this.discounts.discountOfFamily.discountOfFamilyMembers.length == 0
        ) {
          this.newFamilyMember();
        }
        if (
            this.discounts.discountOfMotherOfFourOrMore
                .discountOfMotherOfFourOrMoreChildren == 0
        ) {
          for (var j = 0; j < 3; j++) this.newChild();
        }
        if (
            this.discounts.discountOfMotherOfTwo
                .discountOfMotherOfTwoChildren == 0
        ) {
          for (var i = 0; i < 2; i++) this.newChildForTwo();
        }
        this.syncSectionsWithDiscounts();
        this.loadDictionaries();
      } catch (err) {
        console.error('Error loading employee discounts:', err);
        this.$toast.error({
          title: 'Hiba',
          message: 'Nem sikerült betölteni a kedvezményeket',
        });
      }
    } else {
      this.loadDictionaries();
    }

    if (this.getActiveCompany.taxNumber && !this.userData.evTaxNumber) {
      this.userData.evTaxNumber = this.getActiveCompany.taxNumber;
    }
  },
};
</script>

<style scoped>
.is-invalid {
  background-color: #f9e2e2 !important;
}

.bold {
  font-weight: bold;
}

.hidden {
  display: none !important;
}

#discounts-container.employee-discounts {
  color: #252734;
  padding-left: 0;
  padding-right: 0;
}

.employee-page-title {
  color: #252734;
  font-family: JumperBold;
  font-size: 24px;
  line-height: 1.2;
  margin: 0 0 20px;
}

.employee-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.employee-section-card {
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 20px 40px rgba(37, 39, 52, 0.08);
  padding: 28px;
}

.employee-section-card-disabled {
  background: rgba(255, 255, 255, 0.5);
  box-shadow: none;
}

.employee-section-header {
  margin-bottom: 0;
}

.employee-section-header-plain {
  margin-bottom: 0;
}

.employee-section-title {
  color: #252734;
  flex: 1;
  font-family: JumperBold;
  font-size: 20px;
  line-height: 1.2;
  margin: 0;
  min-width: 0;
}

.employee-section-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #252734;
  display: flex;
  flex: 0 0 auto;
  font-family: JumperBold;
  font-size: 22px;
  justify-content: center;
  padding: 0;
  text-align: left;
}

.employee-section-toggle:focus {
  border-radius: 16px;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.7);
  outline: none;
}

.employee-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 20px;
}

.employee-personal-fields {
  grid-template-columns: minmax(0, 1fr);
}

.employee-field-full {
  grid-column: 1 / -1;
}

.card-body {
  padding: 0 !important;
}

.data-wrapper {
  min-height: auto;
}

.employee-field-title {
  color: #252734;
  display: block;
  font-family: JumperBold;
  font-size: 12px;
  line-height: 1.25;
  margin: 0 0 8px !important;
  padding-left: 20px;
}

.employee-field-heading {
  align-items: center;
  display: flex;
  gap: 6px;
  margin: 0 0 8px;
  padding-left: 20px;
}

.employee-field-heading .employee-field-title {
  margin: 0 !important;
  padding-left: 0;
}

.employee-field-hint {
  color: #252734;
  display: block;
  font-family: JumperThin;
  font-size: 12px;
  line-height: 1.25;
  margin-bottom: 4px;
  padding-left: 20px;
}

.employee-field-sub-title {
  color: #252734;
  display: block;
  font-family: JumperBold;
  font-size: 18px;
  line-height: 1.25;
  margin: 0 0 8px !important;
  padding-left: 10px;
}

.employee-readonly-value {
  color: #6d7684;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  line-height: 1.25;
  margin-bottom: 4px;
  padding-left: 20px;
}

.employee-form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 18px;
}

.employee-toggle-row {
  align-items: center;
  display: flex;
  gap: 12px;
  margin-top: 2px;
}

.employee-toggle-row .employee-toggle-label {
  color: #252734;
  font-family: JumperThin;
  font-size: 12px;
  line-height: 1.25;
}

.validation-error-msg {
  color: #9f1d1d;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  line-height: 1.25;
  padding-left: 20px;
}

#discounts-container.employee-discounts input,
#discounts-container.employee-discounts select,
#discounts-container.employee-discounts .custom-select {
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 32px !important;
  box-shadow: 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  min-height: 42px;
  width: 100% !important;
}

#discounts-container.employee-discounts .employee-personal-date-input {
  width: 50% !important;
}

#discounts-container.employee-discounts input.employee-family-statement-input {
  width: 50% !important;
}

#discounts-container.employee-discounts input::placeholder,
#discounts-container.employee-discounts select option {
  font-family: Poppins, sans-serif !important;
  font-weight: 400 !important;
}

#discounts-container.employee-discounts input:focus,
#discounts-container.employee-discounts select:focus,
#discounts-container.employee-discounts .custom-select:focus-within {
  border-color: #5bb65d !important;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.35), 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  outline: none;
}

#discounts-container.employee-discounts .row {
  margin-left: -8px;
  margin-right: -8px;
}

#discounts-container.employee-discounts .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

.employee-action-column {
  align-items: flex-start;
  display: flex;
  gap: 4px;
  padding-bottom: 0;
  padding-top: 26px;
}

.employee-action-column .btn {
  height: 42px;
  min-height: 42px;
}

.employee-action-column-no-label {
  padding-top: 4px;
}

#discounts-container.employee-discounts .btn-light {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 999px !important;
  box-shadow: 0 8px 18px rgba(37, 39, 52, 0.08);
  display: inline-flex;
  justify-content: center;
  min-height: 38px;
}

#discounts-container.employee-discounts .text-danger {
  color: #9f1d1d !important;
  font-size: 12px;
}

.employee-floating-save-bar {
  align-items: center;
  backdrop-filter: blur(14px);
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(174, 191, 199, 0.85);
  border-radius: 999px;
  bottom: 24px;
  box-shadow: 0 18px 44px rgba(37, 39, 52, 0.16);
  display: flex;
  justify-content: flex-end;
  left: 380px;
  padding: 6px 6px;
  position: fixed;
  width: calc(100% - 460px);
  z-index: 1050;
}

@media (max-width: 768px) {
  #discounts-container.employee-discounts {
    padding-top: 16px !important;
  }

  .employee-fields-grid {
    grid-template-columns: 1fr;
  }

  .employee-layout {
    gap: 16px;
  }

  .employee-section-card {
    border-radius: 28px;
    padding: 20px;
  }

  .employee-section-title {
    font-size: 16px;
  }

  .employee-form-actions {
    justify-content: flex-start;
  }

  .employee-floating-save-bar {
    bottom: 92px;
    justify-content: flex-end;
    left: 0;
    padding: 6px 16px;
    border-radius: 999px;
    width: 100%;
  }

  #discounts-container.employee-discounts .row > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.custom-radio {
  margin-left: 20px;
}
</style>
